/** How a week is written down.
 *
 * `new Date('2026-08-24')` is parsed as UTC per the ECMAScript spec, so
 * anywhere west of Greenwich it renders as the 23rd -- every week labelled
 * with the day before it began, which is both wrong and impossible to spot
 * without knowing to look. Appending a time makes it local midnight instead.
 */
export function localDate(weekStart: string): Date {
  return new Date(`${weekStart}T00:00:00`);
}

export function weekLabel(weekStart: string): string {
  return localDate(weekStart).toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}
